import React from 'react';

import classNames from 'classnames';
import { IconButton } from '@agissc/ktag-map';

export interface IconButtonProps {
  label?: string;
  onClick: () => void;
  active?: boolean;
  iconId: string;
}

const IconSelectButton = ({ iconId, onClick, active, label }: IconButtonProps) => {
  return (
    <li title={label} className="icon-select__button-wrapper">
      <IconButton
        icon={iconId}
        title={label}
        onClick={onClick}
        additionalClassNames={classNames('icon-select__button', {
          'icon-select__button--active': active,
        })}
      />
    </li>
  );
};

export default IconSelectButton;
